import { ApiCallError } from 'app/http/ApiCallError';
import { getApiCallErrorMessage } from 'app/http/getApiCallErrorMessage';

const FALLBACK_MESSAGE = 'Unable to create the API key. Try again.';

export const getCreateApiKeyErrorMessage = (error: unknown): string =>
  error instanceof ApiCallError ? getApiCallErrorMessage(error) : FALLBACK_MESSAGE;
